import React from "react";
import { TableRow, TableCell, Box } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import AnnulledChip from "./AnnulledChip";

const FiledItem = ({ filed, setIsOpenPreview }) => (
  <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
    <TableCell>
      <Box sx={{
        width: 50, height: 60, backgroundColor: 'lightgray', border: 'thin dashed gray', textAlign: 'center'
      }}>
        <img
          alt="preview"
          src={filed.thumbUrl ?? '/pdf.png'}
          height={60}
          style={{ backgroundColor: 'white', maxWidth: 50, objectFit: 'contain' }}
          onClick={(evt) => {
            if (!filed.thumbUrl) return;
            evt.stopPropagation();
            setIsOpenPreview(filed.thumbUrl);
          }}
        />
      </Box>
    </TableCell>
    <TableCell>
      {filed.filedId}
      {filed.status === "CANCELLED" && <AnnulledChip source={filed} sx={{ display: 'flex', width: 'fit-content', mt: 0.5 }} />}
    </TableCell>
    <TableCell>
      {filed.subject}
    </TableCell>
    <TableCell>
      <a
        href={filed.status === "CANCELLED" ? `/filed/cancelled/${filed.filedId}` : `/filed/view/${filed.referenceId}`}
        target="_blank"
        rel="noreferrer"
      >
        <OpenInNewIcon size={20} />
      </a>
    </TableCell>
  </TableRow>
);

export default FiledItem;
